// cross-platform URL api
// - must be ignored by webpack
// - return type of 'any' is used because URL interface is not available in typescript core lib

const URL: any = typeof window !== 'undefined' ?
  window.URL : // web
  require('url').URL; // node

export { URL };
